import React from 'react';
import './App.scss';
import {Navigate} from 'react-router-dom';
import {connect} from 'react-redux';
import {RootState} from './store/reducers';
import {isAuthenticatedSelector} from 'marine-panel-common-web';

interface IConnectedAppProps {
    isAuthenticated: boolean;
}

interface IAppState {
    isAuthenticated: boolean;
}

class App extends React.Component<IConnectedAppProps, IAppState> {
    constructor(props: IConnectedAppProps) {
        super(props);
        this.state = {
            isAuthenticated: this.props.isAuthenticated,
        };
    }

    componentDidUpdate(prevProps: Readonly<IConnectedAppProps>): void {
        if (this.props.isAuthenticated !== prevProps.isAuthenticated) {
            this.setState({isAuthenticated: this.props.isAuthenticated});
        }
    }

    render() {
        const path = this.state.isAuthenticated ? '/panel/operators' : '/auth/login';
        return (
            <div className="App">
                <Navigate replace to={path} />
            </div>
        );
    }
}

export default connect(
    (state: RootState) => ({
        isAuthenticated: isAuthenticatedSelector(state),
    }),
    {}
)(App);
